module.exports = __webpack_public_path__ + "static/media/enterprise.57a8beb6.svg";